module.exports = __webpack_public_path__ + "img/icon-allright2.png";